import { lighten, darken, OPA_10, OPA_20, OPA_30, OPA_40 } from '../themeUtils.js';

// Fixed dark-theme colours from lv_theme_hasp.c (IS_LIGHT = false)
const SCR        = '#545b6a'; // COLOR_SCR (objects background)
const SCR_BG     = '#000000'; // COLOR_SCR_BG dark — the actual root-screen/page background
                               // (LV_THEME_SCR's styles->screen.bg_color); distinct from SCR
                               // above, which is COLOR_SCR (used only for generic "pretty"
                               // object backgrounds, LV_THEME_OBJ), not the screen itself.
const SCR_GRAD   = '#222b3a'; // COLOR_SCR_GRAD
const SCR_TEXT   = '#efefef'; // COLOR_SCR_TEXT
const BORDER     = '#b0b0b0'; // BORDER_COLOR dark
const BTN_BORDER_CHK = '#5f656e';
const BTN_BORDER_DIS  = '#404040'; // COLOR_BTN_BORDER_INA dark (btn's DISABLED-state border)
const TEXT_DEFAULT   = '#eeeeee'; // COLOR_BG_TEXT
const TEXT_PR        = '#ffffff'; // COLOR_BG_TEXT_PR
const TEXT_CHK       = '#ffffff'; // COLOR_BG_TEXT_CHK
const TEXT_DIS       = '#999999'; // COLOR_BG_TEXT_DIS dark
const BTN_DIS        = '#888888'; // COLOR_BTN_DIS dark

export function buildContext(primary, secondary) {
    // Derived button colours — mirrors lv_theme_hasp.c macros
    const btnBg      = lighten(primary,   OPA_30);  // COLOR_BTN
    const btnPr      = lighten(primary,   OPA_10);  // COLOR_BTN_PR
    const btnChk     = secondary;                   // COLOR_BTN_CHK (lighten OPA_0 = no-op)
    const btnChkPr   = darken(secondary,  OPA_20);  // COLOR_BTN_CHK_PR
    const btnBorder  = lighten(primary,   OPA_40);  // COLOR_BTN_BORDER
    const indic      = lighten(primary,   OPA_30);  // pretty_color bg = COLOR_BG = COLOR_BTN
    // const indicGrad  = darken(primary,    OPA_30);  // COLOR_BTN_GRAD (unused)

    // Shared "pretty" style base (used by bg of arc, bar, obj, slider, etc.)
    const pretty = {
        bg_color:     SCR,
        bg_opa:       255,
        border_color: BORDER,
        border_width: 2,
        text_color:   SCR_TEXT,
    };

    // Shared interactive-button style (used by btn, btnmatrix buttons)
    const btnStyle = {
        bg_color:     btnBg,
        bg_opa:       255,
        border_color: btnBorder,
        border_width: 2,
        text_color:   TEXT_DEFAULT,
        // border_color per state mirrors lv_theme_hasp.c:383-385 exactly: firmware's styles->btn
        // only defines border_color for DEFAULT/CHECKED/DISABLED (never PRESSED alone, never a
        // combined CHECKED|PRESSED or DISABLED|CHECKED entry) — LVGL v7's state-style resolution
        // picks the highest-value defined state that's a subset of the object's actual state, so:
        // PRESSED alone (no CHECKED/DISABLED bit) falls back to DEFAULT's border_color (no override
        // needed here); CHECKED|PRESSED falls back to CHECKED's border_color; DISABLED|CHECKED
        // falls back to DISABLED's border_color (its bit outranks CHECKED's). Previously this
        // object wrongly gave PRESSED its own (CHECKED-style) border_color and omitted the
        // CHECKED|PRESSED/DISABLED/DISABLED|CHECKED overrides those fallback rules actually require.
        states: {
            checked:          { bg_color: btnChk,   border_color: BTN_BORDER_CHK, text_color: TEXT_CHK },
            pressed:          { bg_color: btnPr,    text_color: TEXT_PR  },
            pressedChecked:   { bg_color: btnChkPr, border_color: BTN_BORDER_CHK, text_color: TEXT_CHK },
            disabled:         { border_color: BTN_BORDER_DIS, text_color: TEXT_DIS },
            disabledChecked:  { bg_color: BTN_DIS,  border_color: BTN_BORDER_DIS, text_color: TEXT_DIS },
        },
    };

    return {
        primary,
        secondary,
        SCR,
        SCR_BG,
        SCR_GRAD,
        SCR_TEXT,
        BORDER,
        BTN_BORDER_CHK,
        BTN_BORDER_DIS,
        TEXT_DEFAULT,
        TEXT_PR,
        TEXT_CHK,
        TEXT_DIS,
        BTN_DIS,
        btnBg,
        btnPr,
        btnChk,
        btnChkPr,
        btnBorder,
        indic,
        pretty,
        btnStyle,
    };
}
